<div class="button-wrapper">
  <button
    [disabled]="isLoading || disabled"
    [style.height.px]="height"
    [style.maxWidth.px]="maxWidth"
    class="btn button secondary-button global-transition"
    (click)="handleClick($event)"
    [ngClass]="{
            'grey-background': isGreyBackground,
            'white-background': isWhiteBackground,
            'white-with-border': isWhiteBackgroundWithBorder,
            'clean-white': isCleanWhite,
            'green-background': isGreenBackground,
            'primary-background': isPrimaryBackground,
            'amber-background': isAmberBackground,
            'large-button': largeButton,
            'alert-button': alertButton,
            'confirmation-button': confirmationButton,
            'font-weight-500': font500,
            'selected': selected,
            'danger-background':isDangerBackground,
            'with-loader': isLoading,
            'discord-background': isDiscordBackground,
            'red-banner': isRedBanner,
            'yellow-banner': isYellowBanner,
            'green-banner': isGreenBanner,
            'lavender-banner': isLavenderBanner,
            'blue-banner': isBlueBanner,
            'dark-blue-banner': isDarkBlueBanner
        }">
    <div class="small-loader" *ngIf="isLoading"></div>
    <nb-icon pack="icomoon" [icon]="icon" [style.fontSize.px]="iconSize" [style.fontWeight]="iconWeight" class="first-icon button-icon" *ngIf="icon"></nb-icon>
    <span class="button-text" *ngIf="text">{{ text | t }}</span>
    <nb-icon pack="icomoon" [icon]="secondIcon" [style.fontSize.px]="secondIconSize" *ngIf="secondIcon" class="ps-2 second-icon"></nb-icon>
  </button>
</div>
